/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Event_Absent_HintInputs */



/**
* | output |
* | --- |
* | "This event no longer exists on vekn.net. You can delete it here." |
*
* @param {Vekn_Event_Absent_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_event_absent_hint = /** @type {((inputs?: Vekn_Event_Absent_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Event_Absent_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce tournoi n'existe plus sur vekn.net. Vous pouvez le supprimer ici.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este torneo ya no existe en vekn.net. Puede borrarlo aquí.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Este torneio não existe mais na vekn.net. Você pode excluí-lo aqui.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo torneo non esiste più su vekn.net. Puoi eliminarlo qui.")
	return /** @type {LocalizedString} */ ("This event no longer exists on vekn.net. You can delete it here.")
});